export const cvBanner = () => {
  const fv = document.getElementById("section-fv");
  const fvHeight = fv.clientHeight;
  const body = document.body;

  window.addEventListener("scroll", () => {
    const windowPos = window.pageYOffset;
    if (windowPos > fvHeight) {
      body.classList.add("cv-is-active");
    } else {
      body.classList.remove("cv-is-active");
    }
  });
};
